import React, { useState } from "react";
import { motion } from "framer-motion";
import "../GuidedTour.css";

export default function Step3_CreateTest({ onComplete, className }) {
  const [testName, setTestName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!testName.trim()) {
      setError("Please enter a test name");
      return;
    }

    // Instant completion - no API call
    onComplete(testName.trim());
  };

  const handleViewSample = () => {
    window.open("/files/Sample_Question_Paper.pdf", "_blank");
  };

  return (
    <div className="tour-step-container">
      <motion.div
        className="tour-step-full-card"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        {/* Step Header */}
        <div className="tour-step-header">
          <div className="tour-step-icon-large">
            <i className="fa-solid fa-file-alt"></i>
          </div>
          <h2 className="tour-step-title">Create a Test</h2>
          <p className="tour-step-description">
            Create a test for "<strong>{className}</strong>".
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="tour-step-form">
          <div className="demo-form-group">
            <label htmlFor="testName">
              <i className="fa-solid fa-pencil"></i>
              Test Name
              <span className="required">*</span>
            </label>
            <input
              type="text"
              id="testName"
              name="testName"
              placeholder="e.g., Midterm Exam, Quiz 1, Final Assessment"
              value={testName}
              onChange={(e) => setTestName(e.target.value)}
              required
              className="demo-input"
              autoFocus
            />
          </div>

          {/* Sample Question Paper */}
          <div className="demo-info-section">
            <div className="info-header">
              <i className="fa-solid fa-file-pdf"></i>
              Sample Question Paper
            </div>
            <p className="info-description">
              For this tour, we'll use a sample question paper to show you how
              AI grading works.
            </p>
            <div className="sample-actions">
              <button
                type="button"
                className="sample-view-btn"
                onClick={handleViewSample}
              >
                <i className="fa-solid fa-eye"></i>
                View Sample Paper
              </button>
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div className="demo-error">
              <i className="fa-solid fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          {/* Submit Button */}
          <div className="demo-form-actions">
            <button type="submit" className="demo-submit-btn">
              <i className="fa-solid fa-circle-chevron-right"></i>
              Next
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
